import { Form } from "@/shared/form/Form";
import { FormFieldType } from "@/shared/form/FormDefinition";

/**
 * `content.building` — Gebäudebeschreibung of the Bauwerksbuch report.
 *
 * Seeded from the linked building as it exists at report creation and edited
 * per report from then on: the edit never writes back into the building record,
 * and a later change to the building never reaches an existing report.
 */
export interface BauwerksbuchBuildingFormData {
  description: string;
}

export class BauwerksbuchBuildingForm extends Form<
  BauwerksbuchBuildingFormData
> {
  protected definition = {
    description: {
      label: "Gebäudebeschreibung",
      type: FormFieldType.Text,
      required: false
    }
  };
}
